export const Steps = [
  {
    label: "Opened",
    value: "",
    id: 22,
    completed: false,
    order: 1,
    middleStep: "",
  },
  {
    label: "Booked",
    value: "",
    id: 23,
    completed: false,
    order: 5,
    idStep: "",
    middleStep: "",
  },
  {
    label: "Departed",
    value: "",
    id: 18,
    completed: false,
    order: 8,
    middle: false,
    idStep: "",
    middleStep: "",
  },
  {
    label: "Arrived",
    value: "",
    id: 14,
    completed: false,
    order: 19,
    idStep: "step4",
    middleStep: "",
  },
];
